import { usePermissions } from '@/hooks/usePermissions'
import { useRouter } from 'next/compat/router'
import { useSelector } from 'react-redux'

import { Box, HStack, Spacer, Stack, useDisclosure } from '@chakra-ui/react'

import { Button, FiltersButton, SearchInput } from '@/components/ui'
import {
  selectActiveFilter,
  selectIncidentFilterCount,
} from '@/redux/incidents/incidentsSlice'
import { BUTTON_PRESS, trackEvent } from '@/utils/analytics'
import { DASHBOARD } from '@/utils/routes'

import {
  ActiveFilterBadge,
  IncidentsFilterDrawer,
  IncidentsOwnerToggle,
} from '../incidents-filter-drawer'

interface IProps {
  filter?: string
  setFilter?: React.Dispatch<React.SetStateAction<string>>
}

export const IncidentsSearchFilterHeader = ({ filter, setFilter }: IProps) => {
  const { shouldShowMetricsBtn } = usePermissions()
  const { push } = useRouter()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const filterCount = useSelector(selectIncidentFilterCount)
  const activeFilter = useSelector(selectActiveFilter)

  return (
    <>
      <Box
        bgColor='white'
        borderBottom='1px solid #D5DCE4'
        boxShadow='lg'
        px='6'
        py='4'
        w='full'
      >
        <Stack
          alignItems='start'
          direction={{ base: 'column', md: 'row' }}
          justifyContent='start'
          m='auto'
        >
          <HStack spacing='2'>
            <Box
              alignItems='center'
              display='flex'
              flexDir='row'
              maxW='300px'
              w='full'
            >
              <SearchInput
                dataTestId='incidentsPage_tableHeader_search'
                onChange={(e) => setFilter(e.target.value)}
                placeholder='Search or Filter'
                value={filter}
              />
            </Box>
            <IncidentsOwnerToggle />

            {shouldShowMetricsBtn && (
              <Button
                fontSize='12px'
                fontWeight='500'
                h='40px'
                onClick={() => {
                  trackEvent(`${BUTTON_PRESS} Metrics - from Incidents page`)
                  push(DASHBOARD)
                }}
                rounded='6px'
                variant='secondary'
              >
                Metrics
              </Button>
            )}
          </HStack>
          <Spacer />
          <HStack>
            {activeFilter && <ActiveFilterBadge label={activeFilter?.name} />}
            <FiltersButton
              data-testid='incidentsPage_tableHeader_filterButton'
              filterCount={filterCount}
              onOpen={onOpen}
            />
          </HStack>
        </Stack>
      </Box>
      <IncidentsFilterDrawer isOpen={isOpen} onClose={onClose} />
    </>
  )
}
